import { TextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

export type InputProps = Omit<TextFieldProps, 'variant'> & {
  className?: string;
};

export const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return <div className={props.className ? props.className : ""}>
    <TextField variant="outlined" size="small" fullWidth ref={ref} {...props} />
  </div>
});

Input.displayName = 'Input';